import PropTypes from 'prop-types';
import { TableRow, TableCell, TableHead } from '@mui/material';

ListHead.propTypes = {
  headLabel: PropTypes.array,
};

export default function ListHead({ headLabel }) {
  return (
    <TableHead>
      <TableRow>
        {headLabel.map((headCell) =>
          headCell.label !== 'content' ? (
            <TableCell key={headCell.id}>
              {headCell.label || ''}
            </TableCell>
          ) : (
            <TableCell sx={{ width: '700px' }} key={headCell.id} align={'center'}>
              {headCell.label}
            </TableCell>
          )
        )}
      </TableRow>
    </TableHead>
  );
}
